import React from "react";
import ForexChart from "./ForexChart";

function Forex() {
  return (
    <div className="bg-sky-900 md:min-h-screen text-white md:mx-20 rounded-xl">
      <h1 className="text-3xl font-bold p-4">Live Forex Chart</h1>
      <ForexChart />
    </div>
  );
}

export default Forex;
